<!--
  입대업체 그룹목록 조회 화면입니다.
  신규 그룹 생성 및 수정, 삭제가 가능합니다.
 -->
<template>
  <main-layout>
    <template #header>
      <main-header :is-mobile="isMobile" :title="'업무 대행 담당자' | translate"/>

      <search-bar
          v-model="searchOptions.searchKeyword"
          :placeholder="'담당자/담당자 번호' | translate"
          class="search-select"
      />
    </template>


    <template #feature>
    </template>

    <template #body>
      <main-body style="overflow-x: auto">
        <template>
          <div style="text-align: left;min-width: 700px; max-width: 800px; border: 1px solid #eeeeee" class="d-flex justify-space-between align-center">
                <div>{{ '담당자 명' | translate }}</div>
                <input
                    v-model="context.name"
                    data-vv-name="담당자 명"
                    type="text"
                />
                <div>{{ '담당자 번호' | translate }}</div>

                <input
                    v-model="context.amUserId"

                    data-vv-name="담당자 번호"
                    type="text"
                />
                <div>{{ '사용 여부' | translate }}</div>
                <input
                    v-model="context.useYn"
                    type="checkbox"
                    false-value="N"
                    true-value="Y"
                />
            <v-btn elevation="0" color="#F9FCFF" @click="onAddClick">
              <v-icon color="#0C98FE">
                mdi-plus
              </v-icon>
              <span>{{ '담당자 추가' | translate }}</span>
            </v-btn>
          </div>
        </template>

        <div class="d-flex justify-space-between" style="min-width: 1200px; height: calc(100% - 50px);}">
          <div style="width: 40%">
            <!-- 목록 테이블 -->
            <base-table :headers="headers" :is-loading="isLoading" :items="items"
                        :infinity-scroll="infinityScroll"
                        :sort-option="sortOption"
                        :page-number="searchOptions.pageNumber"
                        :page-length="pageLength"

                        @on-click-item="item => onClickItem(item)"
            >
            </base-table>
          </div>
          <div class="px-16" style="width: 60%; height: 100%; ">
            <agency-manager-move-component
              :item="selectedItem"
            ></agency-manager-move-component>
          </div>
        </div>
      </main-body>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/common/layout/MainLayout.vue";
import MainBody from "@/components/common/layout/MainBody.vue";
import MainHeader from "@/components/common/layout/MainHeader.vue";
import {PATH} from "@/constants";
import SearchBar from "@/components/input/SearchBar.vue";
import BaseTable from "@/components/common/newBase/InfinityScrollTable.vue";
import Headers from "@/components/common/newBase/Headers.vue";

import AgencyManagerMoveComponent from "@/views/rental-company/manager/agency-manager/AgencyManagerMoveComponent.vue";

export default {
  name: "AgencyManager",
  components: {
    AgencyManagerMoveComponent,
    SearchBar,
    MainHeader,
    MainBody,
    MainLayout,
    BaseTable,
  },
  extends: Headers,

  data() {
    return {
      headers: [],
      context:{
        name: null,
        amUserId: null,
        useYn: 'Y'
      },
      searchOptions: {
        pageNumber: 1,
        pageSize: 30,
        searchKeyword: undefined,
      },
      isMobile: false,
      addDialog: false,

      // 현대 선택된 행
      selectedItem: undefined,
      showEditPopup: false,



      sortOption: {
        sortBy: ['amUserId'],
        sortDesc: ['true'],
      },
      infinityScroll: true,
      items: [],
      itemsTotalCount: undefined,
      isLoading: false,
    }
  },

  computed: {
    pageLength() {
      if (!this.itemsTotalCount) return 1
      return Math.ceil(this.itemsTotalCount / this.searchOptions.pageSize)
    }
  },

  watch: {
    'searchOptions.searchKeyword': {
      handler(newValue, oldValue) {
        this.onLoad(1)
      }
    },
  },

  created() {
    this.checkMobile();

  },

  beforeMount() {
    this.headers = this.agencyManagerHeader
    this.initPage()
  },

  methods: {
    async onAddClick() {
      if (this.isLoading) return
      try {
        this.isLoading = true
        const res = await this.$request(PATH.AGENCY_MANAGER.ADD)
            .setObject(
                {...this.context}
            )
            .catch()
            .enqueue()
            .then(() => {
              this.context = {}
            }).catch(err => {
              this.$toasted.error(err.response.data.hri)
            })


      } catch (e) {
      } finally {
        this.isLoading = false
        await this.loadData()
      }
    },
    initPage() {
      this.searchOptions.pageNumber = 1;
      this.itemsTotalCount = undefined
      this.items.splice(0, this.items.length)
      this.loadData();
    },

    async loadData() {
      if (this.isLoading) return
      try {
        this.isLoading = true
        const res = await this.$request(PATH.AGENCY_MANAGER.LIST)
            .setObject(
                {...this.searchOptions, ...this.sortOption}
            )
            .catch()
            .enqueue()
        this.items.splice(0, this.items.length)
        this.items.push(...res.data.map((e) => {
          return {
            ...e,
            changeAmUserId: e.amUserId
          }
        }))
      } catch (e) {

        this.$toasted.error('데이터를 불러오는데 실패했습니다.')
      } finally {
        this.isLoading = false
      }
    },
    async onModifyManager(item, type) {
      try {
        if(type === 'useYn') {
          item.useYn = item.useYn === 'Y'? 'N': 'Y'
        }
        const param = {
          ...item,
          type: type,
        }
        await this.$request(PATH.AGENCY_MANAGER.MODIFY)
            .setObject(param)
            .catch()
            .enqueue()
            .then(res => {
              if (!!res) {
                this.$toasted.success('변경이 완료되었습니다.')
                const orgIdx = this.items.findIndex(e => Number(e.amUserId) === Number(item.amUserId))
                this.items.splice(orgIdx, 1, {
                  ...res,
                  changeAmUserId: res.amUserId
                })
              } else {
                this.$toasted.error('변경이 실패했습니다.')
              }
            }).catch(e => {
              this.$toasted.error(`${e.response.data.hri}`)
              this.loadData()
            })
      } catch (e) {
        this.$toasted.error('변경이 실패했습니다.')
      }
    },
    checkMobile() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log('!!!!!!!!!!! t this.isMobile ', this.isMobile);
    },

    onSortChange(option) {
      Object.keys(option).forEach(e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },

    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber
      if (!this.infinityScroll || pageNumber === 1)
        this.items.splice(0, this.items.length)
      this.loadData()
    },

    onClickItem(item) {
      this.selectedItem = item
    },
  },

}
</script>

<style scoped>
input {

  border-bottom: 1px solid #0c98fe;
}
.memo-column {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: inherit;
  width: 500px;
}

.search-select {
  width: 450px;
}

.default-row {
  cursor: pointer;
}
</style>
